import { useEffect } from 'react';
import { Form, Modal } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useAddParentInquiryMutation } from '@/services/parent-api';
import { useGetLettersQuery } from '@/services/general-api';
import Select from '@/components/select';

const AddModal = ({ parentId, open, refetch, onClose }) => {
  const { data: letterData, isLoading: loadingLetterData } = useGetLettersQuery({ parentId });
  const [addInquiry, { isLoading: adding }] = useAddParentInquiryMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    values.parentId = parentId;
    const item = _.find(letterData, { letterId: values.letterId });
    values.recipients = item.recipients;
    values.date = dayjs().toISOString();

    try {
      await addInquiry(values).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Add Inquiry"
      open={open}
      okText="Add"
      confirmLoading={adding}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="letterId" label="Letter" rules={[{ required: true }]}>
          <Select valueName="letterId" options={letterData} loading={loadingLetterData} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
